<template>
    <div>
        <button v-if="!loading" type="button" @click="showDescriptionModal" class="btn btn-icon">
            <i class="fas fa-info"></i>
        </button>
        <span v-else class="spinner-border spinner-border-sm"></span>

        <!-- Description Modal -->
        <div id="description_modal" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="tx_title">
                        </div>
                        <div id="tx_log" class="ml-1">
                        </div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body mb-4">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th class="table-info" colspan="2">
                                    {{ $t('label.detail_money_request_form') }}
                                </th>
                            </tr>
                            </thead>
                            <tbody id="description_details_body">
                            <!-- Description details will be populated here -->
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import toastr from "toastr";
import {bankTransferTransaction, bankTransferTransactionStr} from "@/constants/bankTransferTransaction";
import {openBankingService} from "@/common/api.service";
import {
    openBankingRequestsStatus,
    financialServices,
    authenticationServices,
    inquiryServices
} from '@/constants/openBanking'
import {bankIdStr} from "../../../../constants/bankId";

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            data: {},
            loading: false,
            isError: false,
            openBankingRequestsStatus,
            financialServices,
            authenticationServices,
            inquiryServices,
            bankTransferTransaction,
            selectedStatus: null,
            statusChangeReason: '',
            bankTransferTransactionStr,
            statusChanging: false,
            showChangeStatusModal: false,
            isCancelWithdrawBTNDisabled : false,
            selectedTransaction: null
        }
    },
    methods: {
        showDescriptionModal() {
            if (this.isError)
                return;
            this.loading = true;
          openBankingService.findDeposit(this.row.id)
              .then(({data}) => {
                let tr_body = $('#description_details_body').empty();
                $("#description_modal").modal('show')
                let tx_title = $('#tx_title').empty()
                let tx_log = $('#tx_log').empty()

                $("#description_modal").modal('show')

                let ps_elements = '<h4 class="modal-title float-left p-0 m-0">' + i18n.t('label.transaction_description')+ ' ' + this.row.id + '</h4>'
                tx_title.append(ps_elements)

                if (data.data.transaction_log) {
                  let  ps_elements = '<a href="' + data.data.transaction_log + '" target="_blank" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">' +
                      ' <span class="tooltip-text">لاگ تراکنش</span>'+
                  '<i class="fa fa-history"></i></a>'
                  tx_log.append(ps_elements)
                }

                if (data.data.statement_log) {
                  let  ps_elements = '<a href="' + data.data.statement_log + '" target="_blank" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">' +
                      ' <span class="tooltip-text">لاگ صورت حساب</span>'+
                      '<i class="fa fa-history"></i></a>'
                  tx_log.append(ps_elements)
                }
                tr_body.append(
                    ' <tr><th>' + i18n.t('label.tracking_code') + '</th><th>' + data.data.bank_tracking_code + '</th></tr>' +
                    ' <tr><th>' + i18n.t('transaction_transfer.destination_account') + '</th><th>' + data.data.destination_account_number + '</th></tr>' +
                    ' <tr><th>' + i18n.t('transaction_transfer.origin_account') + '</th><th>' + data.data.origin_account + '</th></tr>' +
                    ' <tr><th>' + i18n.t('transaction_transfer.origin_full_name') + '</th><th>' + data.data.origin_full_name + '</th></tr>'+
                    ' <tr><th>' + i18n.t('label.payment_id') + '</th><th>' + data.data.payment_id + '</th></tr>'+
                    ' <tr><th>' + i18n.t('label.amount_rial') + '</th><th>' + data.data.price + '</th></tr>'+
                    ' <tr><th>' + i18n.t('label.tax') + '</th><th>' + data.data.tax + '</th></tr>'+
                    ' <tr><th>' + i18n.t('label.wage') + '</th><th>' + data.data.wage + '</th></tr>');
              }).finally(() => {
                this.loading = false;
          })


            // if (this.row.pay_id) {
            //     tr_body.append(' <tr><th>' + i18n.t('transaction_transfer.pay_id') + '</th><th>' + this.row.pay_id + '</th></tr>');
            // }
            // if (this.row.reason) {
            //     tr_body.append(' <tr><th>' + i18n.t('transaction_transfer.reason') + '</th><th>' + this.row.reason + '</th></tr>');
            // }
            // if (this.row.type) {
            //     tr_body.append(' <tr><th>' + i18n.t('transaction_transfer.type') + '</th><th>' + this.row.type + '</th></tr>');
            // }
            // if (this.row.transfer_type) {
            //     tr_body.append(' <tr><th>' + i18n.t('transaction_transfer.transfer_type') + '</th><th>' + this.row.transfer_type + '</th></tr>');
            // }
            // if (this.row.status === bankTransferTransaction.FAILED && this.row.description.fail_reason) {
            //     tr_body.append(' <tr><th>' + i18n.t('label.response_rejection_reason') + '</th><th>' + this.row.description.fail_reason + '</th></tr>');
            // }
            // if (this.row.detected_by === 0) {
            //     tr_body.append(' <tr><th>' + i18n.t('open_banking.detected_type') + '</th><th>' + i18n.t('open_banking.detected_automatically') + '</th></tr>');
            // } else if (this.row.detected_by) {
            //     if (this.row.description.change_status_description) {
            //         tr_body.append(' <tr><th>' + i18n.t('transaction_transfer.change_status_description') + '</th><th>' + this.row.description.change_status_description + '</th></tr>');
            //     }
            //     tr_body.append(' <tr><th>' + i18n.t('open_banking.detected_by') + '</th><th><a href="/users/' + this.row.detected_by.id + '/details" target="_blank">' + this.row.detected_by.name + '</a></th></tr>');
            // }
        },
        async confirmStatusChange() {
            if (!this.selectedStatus) {
                this.toastr.error('لطفاً وضعیت جدید را انتخاب کنید');
                return;
            }

            this.statusChanging = true;

            try {
                const response = await openBankingService.adminChangeTransactionStatus(this.row.id, {
                    new_status: this.selectedStatus,
                    description: this.statusChangeReason
                });

                this.toastr.success('وضعیت تراکنش با موفقیت تغییر یافت');
                this.datatable.reload();
                this.closeStatusModal();
            } catch (error) {
                this.toastr.error('خطا در تغییر وضعیت: ' + error.message);
            } finally {
                this.statusChanging = false;
            }

        },
        moneyFormat(price) {
            if (!price) return 0;
            const pieces = parseFloat(price).toFixed(0).split("");
            let ii = pieces.length;
            while ((ii -= 3) > 0) {
                pieces.splice(ii, 0, ",");
            }
            return pieces.join("");
        },
    },
    computed: {
        bankIdStr() {
            return bankIdStr
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    }
})
</script>
<style scoped>
.modal {
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-backdrop {
    opacity: 0.5;
}
.tooltip-wrapper {
    position: relative;
    display: inline-block;
}

.tooltip-text {
    visibility: hidden;
    background-color: #333;
    color: #fff;
    font-size: 12px;
    text-align: center;
    padding: 5px 8px;
    border-radius: 4px;

    /* positioning */
    position: absolute;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;

    opacity: 0;
    transition: opacity 0.2s;
}

.tooltip-wrapper:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}
</style>
